import DatabaseWorker from '@/database-worker';
import {isProxy, toRaw} from 'vue';
window.database_worker = DatabaseWorker;
import { createStore } from 'vuex'
import axios from 'axios';
import dayjs from 'dayjs';
import ItemStore from './items';
import PlayerStore from './players';

import database from './db';
import crimes from '../constants/crimes';
import {INTERACTION_FIELDS, INTERACTION_FIELDS as PLAYER_DATA_FIELD_NAMES} from '../constants/players';
const local_storage = window.localStorage;
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
window.sleep = sleep;

function download(filename, text) {
    var element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    element.setAttribute('download', filename);
  
    element.style.display = 'none';
    document.body.appendChild(element);
  
    element.click();
  
    document.body.removeChild(element);
  }

DatabaseWorker.addActionHandler("GET_PLAYERS_INTERACTIONS", (message) => {
    store.commit('addPlayers', message);
    store.commit('setCalculatingInteractions', false);
});

DatabaseWorker.addActionHandler("GET_FILTERED_LOGS", (message) => {
    store.commit('setLogs', message);
    store.commit('setLogsLoading', false);
});

DatabaseWorker.addActionHandler("GENERATE_GYM_DATA", (message) => {
    store.commit('setGymData', message);
});

DatabaseWorker.addActionHandler("GENERATE_CRIME_DATA", (message) => {
    store.commit('setCrimeData', message);
});

DatabaseWorker.addActionHandler("WORKER_READY", (message) => {
    console.log("[main] WORKER_READY", message);
    store.commit('setWorkerReady', true);
});



function renderDataField(data, key, players) {
    // Return as-is
    if (isNaN(data)) return data;

    // Return Player name / id / link
    if (INTERACTION_FIELDS.includes(key)) {
        let player = players[data];
        if (player) {
            return `<a class="log-link" href="https://www.torn.com/profiles.php?XID=${player.id}">${player.name} [${player.id}]</a>`;
        }
        else return `[${data}]`;
    }
    
    // Return formatted integer
    if (Math.ceil(data) == data) return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    
    // Return formatted float.
    return parseFloat(data).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}


window.database = database;
import Dexie from 'dexie';
window.Dexie = Dexie;


const store = createStore({
    state: {
        logs: [],
        gym_data: null,
        crime_data: null,
        players: {},
        items: {},
        stats: {
            total_logs: null,
        },
        auth: {
            key: local_storage.auth_key || null
        },
        sync: {
            enabled: false,
            earliest_timestamp: local_storage.earliest_timestamp || null,
            latest_timestamp:  local_storage.latest_timestamp || null,
            fetching_players: false,
            fetching_logs: false,
            calculating_interactions: false,
            fetching_items: false,
            items_last_indexed: local_storage.items_last_indexed || null,
            worker_ready: false,
        },
        filter_options: {
            categories: null,
        },
        filters: {
            date: {
                start: null,
                end: null,
            },
            category: null,
            log_type: null,
            player_id: null,
            color: null,
        },
        pagination: {
            page: 1,
            limit: 200,
        },
        navigation: {
            screen: null,
        },
        loading: {
            logs: false,
        }
    },

    mutations: {
        setWorkerReady(state, value) {
            state.sync.worker_ready = value;
        },

        setAuthKey(state, key) {
            state.auth.key = key;
            local_storage.auth_key = key;
        },

        setLogTimestamp(state, time) {
            if (state.sync.earliest_timestamp === null || state.sync.earliest_timestamp > time) {
                state.sync.earliest_timestamp = time;
                local_storage.earliest_timestamp = time;
            }
        },

        setSyncEnabled(state, value) {
            state.sync.enabled = value;
        },

        setLogs(state, value) {
            state.logs = value;
        },
        
        setTotalLogs(state, value) {
            state.stats.total_logs = value;
        },

        setSyncDates(state, values) {
            state.sync.earliest_timestamp = values.oldest || state.sync.earliest_timestamp;
            state.sync.latest_timestamp = values.newest || state.sync.latest_timestamp;
        },

        setFetchingLogs(state, value) {
            state.sync.fetching_logs = value;
        },

        setCalculatingInteractions(state, value) {
            state.sync.calculating_interactions = value;
        },

        setFetchingPlayers(state, value) {
            state.sync.fetching_players = value;
        },
      
        ...ItemStore.mutations,
        ...PlayerStore.mutations,

        setFilter(state, {filter, value}) {
            // console.log("Setting filter: ", filter, value);
            state.filters[filter] = value;
        },
        setFilters(state, filters) {
            state.filters= filters;
        },

        clearFilters(state) {
            state.filters = {
                date: {
                    start: null,
                    end: null,
                },
                category: null,
                log_type: null,
                player_id: null,
                color: null,
            };
        },

        setPage(state, page) {
            state.pagination.page = page;
        },

        setCurrentScreen(state, screen) {
            state.navigation.screen = screen;
        },

        setLogsLoading(state, value){
            state.loading.logs = value;
        },

        setGymData(state, data) {
            state.gym_data = data;
        },
        setCrimeData(state, data) {
            state.crime_data = data;
        },
        
    },

    actions: {
        ...ItemStore.actions,
        ...PlayerStore.actions,
        // LOGS
        async fetchNewLogs(context, reload) {
            if (context.state.sync.fetching_logs) {
                // console.log("Not syncing due to: ",  context.state.sync.fetching_logs  ? 'already fetching logs' : 'no timestamp');
                return;
            }

            context.commit('setFetchingLogs', true);
            
            let latest_timestamp = context.state.sync.latest_timestamp;
            let current_timestamp = null;

            while (!current_timestamp || current_timestamp > latest_timestamp) {
                let selection = `?selections=log`;
                if (current_timestamp) selection= `${selection}&to=${current_timestamp}`;
                
                let url = `https://api.torn.com/user${selection}&key=${context.state.auth.key}`;

                try {
                    let response = await axios.get(url);
                    let data = response.data;

                    if (!data.log) {
                        // Reached the end of the log, or some other problem.
                        break;
                    };
                        
                    // 
                    let keys = Object.keys(data.log);

                    let logs = keys
                        .map(key => {
                            data.log[key].id = key;
                            return data.log[key];
                        })
                        .sort(function (a, b) {
                            if (a.timestamp > b.timestamp) return -1;
                            if (a.timestamp < b.timestamp) return 1;
                            else return 0;
                        });

                    context.dispatch('addLogs', logs, reload);

                    let last_log = logs[logs.length -1];
                    current_timestamp = last_log.timestamp;
                    
                    await sleep(600);
                } catch (error) {
                    console.log("Error fetching logs: ", error, latest_timestamp, current_timestamp);
                    return;
                }
            }


            context.commit('setFetchingLogs', false);
            context.commit('setSyncDates', {newest: current_timestamp});
        },

        addLogs(context, logs, reload) {
            logs.forEach(log => {
                database.log_entries.add(log);
            });
            if (reload) context.dispatch('getLogs');
            
        },
        

        async getLogs(context, filters) {
            context.commit('setLogsLoading', true);
            let current_screen = context.state.navigation.screen || 'Home';
            if (filters) {
                context.commit('setFilters', filters);
            }

            let store_filters = toRaw(context.state.filters);


            DatabaseWorker.send({
                action: 'GET_FILTERED_LOGS',
                filters: {
                    ...store_filters,
                    current_screen
                }
            });

            let newest =   await database.log_entries.orderBy('timestamp').reverse().limit(1).first();
            let oldest =   await database.log_entries.orderBy('timestamp').limit(1).first();
            let count =    await database.log_entries.orderBy('timestamp').count();
            context.commit('setTotalLogs', count);
            context.commit('setSyncDates', {
                newest: newest?.timestamp,
                oldest: oldest?.timestamp
            });
        },

        async generateGymData(context, payload) {
            let filters = {...toRaw(context.state.filters)};

            DatabaseWorker.send({
                action: 'GENERATE_GYM_DATA',
                filters,
            });
        },

        async generateCrimeData(context, payload) {
            let filters = {...toRaw(context.state.filters)};

            DatabaseWorker.send({
                action: 'GENERATE_CRIME_DATA',
                filters,
            });
        },

        async exportAllData(context, payload) {
            let log_entries = await database.log_entries.orderBy('timestamp').toArray();
            // console.log("export", log_entries);

            let log_json = JSON.stringify(log_entries, null, 4);
            download('torn-log-data-all-logs.json', log_json);
            log_entries = null;
            log_json = null;

            let players = await database.players.orderBy('id').toArray();
            let players_json = JSON.stringify(players, null, 4);
            download('torn-log-data-all-players.json', players_json);
            players = null;
            players_json = null;

            // let players = await database.players.orderBy('id').toArray();
            // let players_json = JSON.stringify(players, null, 4);
            // download('torn-log-data-all-players.json', players_json);
        },

        async databaseExec(contexct, callback) {
            callback(database);
        },

        
    },



    
    getters: {

        logs (state, getters) {
            return state.logs;
        },

        referenced_players(state, getters) {
            let players = {};
            getters.logs.forEach(log => {
                Object.keys(log.data || {}).forEach(key => {
                    if (PLAYER_DATA_FIELD_NAMES.includes(key)) {
                        players[log.data[key]] = log.data[key];
                    }
                })
            });
            return Object.keys(players).filter((id, index, self)=> id > 0);
        },


        // ATTACKS

        attacks(state, getters) {
            return state.attack_logs.map(log => {
                if (!log?.data) {
                    log.data = [];
                }
                log.formatted_date = dayjs.unix(log.timestamp).format('YYYY-MM-DD HH:mm:ss')
                let data_keys = Object.keys(log.data);
                data_keys.filter(key => !key.includes('_formatted')).forEach(key => {
                    log.data[`${key}_formatted`] = renderDataField(log.data[key], key, getters.players);
                })
                return log;
            });;
        },

        incoming_attacks(state, getters) {
            return getters.attacks.filter(log => log.title.includes('receive'));
        },
        
        outgoing_attacks(state, getters) {
            return getters.attacks.filter(log => !log.title.includes('receive'));
        },

 
        // GYM
        gym(state, getters) {
            return state.gym_logs.map(log => {
                if (!log?.data) {
                    log.data = [];
                }
                log.formatted_date = dayjs.unix(log.timestamp).format('YYYY-MM-DD HH:mm:ss')
                let data_keys = Object.keys(log.data);
                data_keys.filter(key => !key.includes('_formatted')).forEach(key => {
                    log.data[`${key}_formatted`] = renderDataField(log.data[key], key, getters);
                })
                return log;
            });;
        },

        // PLAYERS
        players(state, getters) {
            return state.players;
        },

        // MISC
        database(state, getters) {
            return database;
        }

    },
    modules: {
    }
})



export default store;